module.exports = __webpack_public_path__ + "fonts/Golos-Text_Medium.3f8ab55.ttf";